import SideBar from "./SideBar";
import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import AddressList from "./components/AddressList";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { fetchAddresses } from "../../redux/action/authAction";

const AddressDetail = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.authReducer);

  useEffect(() => {
    dispatch(fetchAddresses());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 className="mb-1">{"Address Detail"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Address Detail", path: `${pageRoutes?.home}/` },
        ]}
      />
      <div class="untree_co-section ">
        <div class="container">
          <div class="row mb-5">
            <SideBar />
            <AddressList />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AddressDetail;
